var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E-cabinet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "E-cabinet-Home---Move-popup---home-folder---loader",
    transform: "translate(-733.000000, -688.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-folder-popup",
    transform: "translate(465.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "internal-content",
    transform: "translate(32.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Loading",
    transform: "translate(236.000000, 271.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9135504,12.5450185 C21.8526261,15.4065393 20.6625152,18.178215 18.710433,20.1007243 C16.7696176,22.0393708 14.1081424,23.0939597 11.4813024,23.0124013 C8.85154133,22.9474163 6.3110803,21.751954 4.5471958,19.7923727 C2.76954075,17.8428226 1.80601832,15.1775653 1.88363425,12.5450185 C1.94664502,9.90985489 3.04411751,7.37064228 4.84221978,5.60601599 C6.63197624,3.82874162 9.07103583,2.87010381 11.4813024,2.94991761 C13.89449,3.01664717 16.2125355,4.11572237 17.8253611,5.91436764 C19.4490361,7.70559852 20.3199202,10.1383927 20.2443907,12.5450185 L24,12.5450185 C23.9545154,10.8366544 23.5889694,9.13832155 22.9258957,7.58958503 C22.2649085,6.03910395 21.3130702,4.63909151 20.1488313,3.48593483 C17.8261956,1.16740954 14.6214091,-0.0982714932 11.4813024,0.00596619383 C8.33785744,0.0849077058 5.28371251,1.52635355 3.18224048,3.87148343 C1.06032123,6.20003997 -0.0926508146,9.40436752 0.00582960644,12.5450185 C0.0826109517,15.6891586 1.40416813,18.7356031 3.55112477,20.833005 C5.68431084,22.9504693 8.61159962,24.0957754 11.4813024,23.9937184 C14.3547608,23.9125962 17.130156,22.5910891 19.0421785,20.4478925 C20.9717271,18.3169078 22.0099444,15.4030502 21.9135504,12.5450185",
    id: "Fill-1",
    fill: "#616674"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.8d4a35412a8bb171e1b9ab85ad9e63f9.svg";
export { ForwardRef as ReactComponent };